import { useTimelineContext } from 'context/TimelineContext'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import {
  IResolvedVisualMediaPlacement,
  resolveVisualMediaPlacement
} from 'utils/visualMediaPlacement'

export const useVisualMediaPlacement = () => {
  const existingMediaItems = useSelector(projectDataSelectors.mediaItems)
  const { getCurrentTimeImmediate } = useTimelineContext()

  const getPlacement = useCallback(
    (newDuration: number): IResolvedVisualMediaPlacement => {
      const playheadTime = getCurrentTimeImmediate()
      return resolveVisualMediaPlacement({
        playheadTime,
        newDuration,
        existingMediaItems
      })
    },
    [getCurrentTimeImmediate, existingMediaItems]
  )

  return getPlacement
}
